import React, {PureComponent} from 'react';
import {formatMinutes, getAngle, getPointInArc, YouTubeGetID} from "../functions/utils";
import Track from "./trackComponent";
import ReactTooltip from "react-tooltip";

import gMarker from "../../img/gMarker.png";
import gMeter from "../../img/gMeter.png";
import $ from "jquery";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";
import {subscribeClock} from "../functions/api";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

const super_admin = parseInt(process.env.REACT_APP_SUPER_ADMIN_ID);
const admin = parseInt(process.env.REACT_APP_EVENT_ADMIN_ID);
const sub_admin = parseInt(process.env.REACT_APP_EVENT_SUB_ADMIN_ID);

class BottomRow extends PureComponent {

    constructor(props) {
        super(props);
        this.popoutStream = this.popoutStream.bind(this);
    }

    popoutStream() {
        let params = "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no, width=500,height=500,left=200,top=200";
        window.open("expandStream/" + YouTubeGetID(this.props.youtubeStream), 'stream', params);
    }

    render() {
        return (
            <div className={"row row-flex"} style={{marginTop: 10}}>
                <div className={"col-xs-12 col-sm-8"}>
                    <div className={"App_sectionContainer"} style={{height: "100%"}}>
                        <Track
                            isOwnTeam={this.props.isOwnTeam}
                            isGuest={this.props.isGuest}
                            updateCurrentCarID={this.props.updateCurrentCarID}
                            eventID={this.props.eventID}
                            sessionID={this.props.sessionID}
                            carID={this.props.carID}
                            carList={this.props.carList}
                            mapCenterLat={this.props.mapCenterLat}
                            mapCenterLng={this.props.mapCenterLng}
                            mapZoomLevel={this.props.mapZoomLevel}
                            mapRotation={this.props.mapRotation}
                            toggleCarList={this.props.toggleCarList}
                            activeTab={this.props.activeTab}
                            sessionFlagStatus={this.props.sessionFlagStatus}
                            privileges={this.props.privileges}
                            marshallPosts={this.props.marshallPosts}
                        />
                    </div>
                </div>
                <div className={"col-xs-12 col-sm-4"}>
                    <div className={"col-xs-12"} style={{padding: 0}}>
                        <GMeter
                            isOwnTeam={this.props.isOwnTeam}
                            isGuest={this.props.isGuest}
                            speed={this.props.telemetry.speed}
                            gLat={this.props.telemetry.accel[0] * -1}
                            gLong={this.props.telemetry.accel[1]}
                            radius={(this.props.telemetry.accel[0] + this.props.telemetry.accel[1]) / 2}
                            privileges={this.props.privileges}
                        />
                    </div>
                    <div className={"col-xs-12"} style={{marginTop: 15, padding: 0}}>
                        <PitStopSignal
                            pli={this.props.telemetry.pli}
                            pet={this.props.telemetry.pet}
                            speed={this.props.telemetry.spg}
                            pitlaneSpeedLimit={this.props.pitlaneSpeedLimit}
                            pitMinimumTime={this.props.pitMinimumTime}
                            isOwnTeam={this.props.isOwnTeam}
                            privileges={this.props.privileges}
                            carID={this.props.carID}
                            t={this.props.t}
                            cookies={this.props.cookies}
                            eventID={this.props.eventID}
                            sessionID={this.props.sessionID}
                        />
                        <button
                            type={"button"}
                            data-tip={true}
                            data-for={"stream"}
                            className={"btn btn-primary button"}
                            onClick={this.popoutStream}
                            disabled={(this.props.isOwnTeam === 0 || this.props.isGuest || !this.props.youtubeStream || this.props.youtubeStream.length === 0)}
                            style={{padding: 10}}
                        >
                            <i className={"fas fa-video App_buttonContainer_icons"}/>
                        </button>
                        <ReactTooltip id={"stream"} type={"light"}>
                            <span className={"toolTipStyle"}>{this.props.t("videoStream")}</span>
                        </ReactTooltip>
                    </div>
                </div>
            </div>
        );
    }
}

class GMeter extends PureComponent {

    constructor(props) {
        super(props);
        // Fix center of diagram at beginning
        this.state = {
            radius: 0,
            center: [87, 63],
            coords: [87, 63],
            counter: 0
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.gLat !== this.props.gLat || prevProps.gLong !== this.props.gLong) {
            const angle = getAngle(0, 0, this.props.gLat, this.props.gLong * -1);
            const radius = Math.abs(this.props.radius * 40);
            this.setState({
                coords: getPointInArc((radius >= 70 ? 70 : radius), angle, this.state.center[0], this.state.center[1]),
            });
        }
    }

    render() {

        const gMarkerStyle = {
            position: "absolute",
            left: (isNaN(this.state.coords[0]) ? this.state.center[0] : this.state.coords[0]),
            top: (isNaN(this.state.coords[1]) ? this.state.center[1] : this.state.coords[1]),
            zIndex: 10,
        };

        return (
            <div className={"App_sectionContainer App_centerGmeter"}>
                <div className={"col-xs-8"} style={{width: 185, height: 140, textAlign: "center", padding: 0}}>
                    <img
                        alt=""
                        className={"gMeter_animation"}
                        style={gMarkerStyle}
                        src={gMarker}
                        height={13}
                    />
                    <img
                        alt={""}
                        className={"img-responsive"}
                        src={gMeter}
                        style={{
                            height: 140,
                            width: 140,
                            margin: "0 auto",
                            padding: 0,
                            position: "relative",
                        }}
                    />
                </div>
                <div className={"col-xs-4"} style={{padding: 5}}>
                    <div className={"col-xs-12"} style={{padding: 0}}>
                            <span className={"App_gMeter_legend"}>
                            X: <b style={{color: "#FFFFFF"}}>{(Math.round(parseFloat(this.props.gLat) * 10) / 10).toFixed(1)} G</b>
                            </span>
                    </div>
                    <div className={"col-xs-12"} style={{padding: 0}}>
                            <span className={"App_gMeter_legend"}>
                            Y: <b style={{color: "#FFFFFF"}}>{(Math.round(parseFloat(this.props.gLong) * 10) / 10).toFixed(1)} G</b>
                            </span>
                    </div>
                </div>
            </div>
        );
    }
}

class PitStopSignal extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            text: "---",
            textColor: "#000000",
            pitEntry: -1,
            now: new Date().getTime(),
            timer: 0,
        };

        this.getLastestPitRegistry = this.getLastestPitRegistry.bind(this);
    }

    componentDidMount() {
        subscribeClock((obj) => {
            this.setState({
                now: obj.tim,
            });
        });
    }

    componentWillUnmount() {
        subscribeClock(null);
        clearInterval(this.pitTimer);
        console.log("[PIT SIGNAL] Timer cleared");
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.carID !== this.props.carID) {
            if (this.props.pli !== 0) {
                this.getLastestPitRegistry((entry_time, exit_time) => {
                    this.setState({
                        pitEntry: entry_time,
                        pitExit: exit_time,
                    });
                });
            } else {
                clearInterval(this.pitTimer);
            }
        }

        if (prevProps.pli !== this.props.pli) {
            if ([1, 2, 3].includes(this.props.pli)) {
                this.getLastestPitRegistry((entry_time, exit_time) => {
                    this.setState({
                        pitEntry: entry_time,
                        timer: 0,
                    }, () => {
                        this.pitTimer = setInterval(() => {
                            this.setState({
                                timer: Math.abs(this.state.now - this.state.pitEntry),
                            });
                        }, 1000);
                    });
                });
            }
            switch (this.props.pli) {
                case (0): {
                    this.setState({
                        text: this.props.t("onTrack").toUpperCase(),
                        textColor: "#FFFFFF",
                        timer: 0,
                    }, () => {
                        clearInterval(this.pitTimer);
                    });
                    break;
                }
                case (1): {
                    this.setState({
                        text: this.props.t("pitEntry").toUpperCase(),
                        textColor: "#007bff",
                    });
                    break;
                }
                case(2): {
                    this.setState({
                        text: this.props.t("box").toUpperCase(),
                        textColor: "#ffc700",
                    });
                    break;
                }
                case(3): {
                    this.setState({
                        text: this.props.t("pitExit").toUpperCase(),
                        textColor: "#007bff",
                    });
                    break;
                }
                case(4): {
                    this.setState({
                        text: this.props.t("outLap").toUpperCase(),
                        textColor: "#00ff1b",
                        timer: 0,
                    }, () => {
                        clearInterval(this.pitTimer);
                    });
                    this.getLastestPitRegistry((entry_time, exit_time) => {
                        this.setState({
                            latestPitTime: exit_time - entry_time,
                        });
                    });
                    break;
                }
                default: {
                    this.setState({
                        text: "---",
                        textColor: "#ffffff",
                    });
                    break;
                }
            }
        }
    }

    getLastestPitRegistry(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getLastestPitRegistry',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.sessionID,
                carID: helper.props.carID,
            },
            success: function (data) {
                if (data && data.length > 0) {
                    callback(data[0].entry_time, data[0].exit_time);
                }
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        });
    }

    render() {
        if (this.props.pit !== null) {
            return (
                <div className={"App_sectionContainer App_pitStatusContainer"}>
                    <p className={"App_pitStatusTitle"} style={{color: this.state.textColor, fontWeight: "bold"}}>
                        {this.state.text}
                    </p>
                    {(this.props.isOwnTeam === 1 || (this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin))) ? (
                        (this.props.pli === 1 || this.props.pli === 3) ? (
                            <p className={"App_pitStatusInfoText"} style={{color: (this.props.speed > this.props.pitlaneSpeedLimit ? "#ff1600" : "#FFFFFF"),}}>
                                {(this.props.speed < 400 ? this.props.speed : "---")} km/h
                            </p>
                        ) : (
                            <div/>
                        )
                    ) : (
                        <div/>
                    )}
                    {(this.props.isOwnTeam === 1 || (this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin))) ? (
                        [1, 2, 3].includes(this.props.pli) ? (
                            <p className={"App_pitStatusInfoText"} style={{color: (this.props.pitMinimumTime > (this.props.pet / 1000) ? "#ff1600" : "#0ebe00")}}>
                                {formatMinutes(this.state.timer)}
                            </p>
                        ) : (
                            <div/>
                        )
                    ) : (
                        <div/>
                    )}
                    {(this.props.isOwnTeam === 1 || (this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin))) ? (
                        (this.props.pli === 4 && this.state.latestPitTime > 0) ? (
                            <div>
                                <p className={"App_pitStatusInfoText"}>
                                    {this.props.t("pitTime").toUpperCase()}
                                </p>
                                <p className={"App_pitStatusInfoText"} style={{color: (this.props.pitMinimumTime > this.state.latestPitTime / 1000 ? "#ff1600" : "#0ebe00")}}>
                                    <b className={"blink"}>{formatMinutes(this.state.latestPitTime)}</b>
                                </p>
                            </div>
                        ) : (
                            <div/>
                        )
                    ) : (
                        <div/>
                    )}
                </div>
            );
        } else {
            return (
                <div/>
            );
        }
    }
}

export default withTranslation("translations")(withCookies(BottomRow));